import { BrowserRouter } from "react-router-dom";
import { useState } from "react";

import Router from "./routes";
import { AuthProvider } from "./context/AuthContext";
import { FormProvider } from "./context/FormContext";
import { EditorProvider } from "./context/EditorContext";
import { ClaimProvider } from "./context/ClaimContext";
import { TourProvider } from "./context/TourContext";
import { UnsavedChangesProvider } from "./context/UnsavedChangesContext";
import CommandPalette from "./components/CommandPalette";
import { useKeyboardShortcuts } from "./hooks/useKeyboardShortcuts";

import "./App.css";

function AppContent() {
  const [commandPaletteOpen, setCommandPaletteOpen] = useState(false);

  useKeyboardShortcuts({
    onSearchOpen: () => setCommandPaletteOpen(true),
    onModalClose: () => setCommandPaletteOpen(false),
  });

  return (
    <>
      <Router />
      <CommandPalette
        visible={commandPaletteOpen}
        onClose={() => setCommandPaletteOpen(false)}
      />
    </>
  );
}

function App() {
  return (
    <>
      <BrowserRouter>
        <AuthProvider>
          <UnsavedChangesProvider>
            <TourProvider>
              <FormProvider>
                <EditorProvider>
                  <ClaimProvider>
                    <AppContent />
                  </ClaimProvider>
                </EditorProvider>
              </FormProvider>
            </TourProvider>
          </UnsavedChangesProvider>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
